import React from 'react';

const s = {
  page:    { maxWidth: '720px', margin: '0 auto', padding: '4rem 1.5rem 6rem' },
  eyebrow: { fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.15em', color: 'var(--blue-soft)', fontWeight: 500, marginBottom: '0.5rem' },
  h1:      { fontFamily: "'Playfair Display', serif", fontSize: 'clamp(2rem, 4vw, 2.8rem)', color: 'var(--ink)', marginBottom: '0.5rem', fontWeight: 700 },
  date:    { fontSize: '0.82rem', color: 'var(--muted)', marginBottom: '2.5rem' },
  h2:      { fontFamily: "'Playfair Display', serif", fontSize: '1.2rem', color: 'var(--ink)', margin: '2rem 0 0.6rem', fontWeight: 700 },
  p:       { fontSize: '0.95rem', color: 'var(--muted)', lineHeight: 1.85, marginBottom: '1rem' },
  ul:      { paddingLeft: '1.4rem', marginBottom: '1rem' },
  li:      { fontSize: '0.95rem', color: 'var(--muted)', lineHeight: 1.85, marginBottom: '0.3rem' },
  link:    { color: 'var(--blue)', textDecoration: 'underline' },
  divider: { border: 'none', borderTop: '1px solid var(--border)', margin: '2.5rem 0' },
  pledge:  { background: 'var(--blue-faint)', border: '1px solid var(--border)', borderRadius: '12px', padding: '1.2rem 1.5rem', margin: '1.5rem 0' },
};

export default function TermsOfService() {
  return (
    <div style={s.page}>
      <div style={s.eyebrow}>Legal</div>
      <h1 style={s.h1}>Terms of Service</h1>
      <p style={s.date}>Last updated: April 11, 2026</p>

      <p style={s.p}>
        By using ArmenianPlace ("the platform"), you agree to these terms. Please read them carefully. If you do not agree, do not use the platform.
      </p>

      <hr style={s.divider} />

      <h2 style={s.h2}>The community pledge</h2>
      <div style={s.pledge}>
        <p style={{ ...s.p, marginBottom: 0, color: 'var(--ink)', fontStyle: 'italic' }}>
          "I give my word that I will be genuine and helpful to this community — sharing honest ideas, treating others with respect, and contributing in good faith."
        </p>
      </div>
      <p style={s.p}>
        By signing in and participating, you agree to uphold this pledge. ArmenianPlace is built on trust. Contributions made in bad faith — spam, self-promotion without value, misinformation, or harassment — are grounds for removal.
      </p>

      <h2 style={s.h2}>Who can use this platform</h2>
      <ul style={s.ul}>
        <li style={s.li}>Anyone who supports the Armenian community and its values</li>
        <li style={s.li}>You must be 13 years of age or older</li>
        <li style={s.li}>You must sign in with a valid Google account</li>
      </ul>

      <h2 style={s.h2}>What you can do</h2>
      <ul style={s.ul}>
        <li style={s.li}>Submit suggestions for what ArmenianPlace should become</li>
        <li style={s.li}>Leave feedback and star ratings on other suggestions</li>
        <li style={s.li}>Upvote suggestions you support</li>
        <li style={s.li}>Edit or delete your own contributions at any time</li>
      </ul>

      <h2 style={s.h2}>What you may not do</h2>
      <ul style={s.ul}>
        <li style={s.li}>Post spam, advertising, or irrelevant content</li>
        <li style={s.li}>Harass, threaten, or demean other community members</li>
        <li style={s.li}>Impersonate another person or organization</li>
        <li style={s.li}>Submit false or misleading information</li>
        <li style={s.li}>Use the platform for any commercial purpose without permission</li>
        <li style={s.li}>Attempt to scrape, hack, or disrupt the platform</li>
      </ul>

      <h2 style={s.h2}>Seminars &amp; recordings</h2>
      <p style={s.p}>
        Seminars hosted through ArmenianPlace may be recorded (audio, video, and any content shared during the session). By attending or speaking at a seminar, you consent to being recorded and to that recording being published publicly, including on YouTube or similar platforms, for the benefit of the wider community.
      </p>
      <p style={s.p}>
        Speakers retain ownership of the expertise and content they present, but grant ArmenianPlace a non-exclusive license to record, edit, publish, and distribute that session as part of the public archive. If you'd prefer not to appear on camera, you can keep your camera off and participate via chat or Q&amp;A instead.
      </p>

      <h2 style={s.h2}>Your content</h2>
      <p style={s.p}>
        You own the content you submit. By posting, you grant ArmenianPlace a non-exclusive license to display it on the platform. You can delete your content at any time. We will not use your content for commercial purposes.
      </p>

      <h2 style={s.h2}>Platform availability</h2>
      <p style={s.p}>
        ArmenianPlace is provided free of charge and as-is. We reserve the right to modify, suspend, or discontinue the platform at any time. We are not liable for any loss of data or access.
      </p>

      <h2 style={s.h2}>Enforcement</h2>
      <p style={s.p}>
        We reserve the right to remove content or suspend accounts that violate these terms or the spirit of the community pledge, at our sole discretion.
      </p>

      <h2 style={s.h2}>Changes to these terms</h2>
      <p style={s.p}>
        We may update these terms from time to time. The date at the top of this page will reflect the latest version. Continued use of the platform constitutes acceptance.
      </p>

      <h2 style={s.h2}>Contact</h2>
      <p style={s.p}>
        Questions? Email <a href="mailto:hello@armenianplace.com" style={s.link}>hello@armenianplace.com</a>
      </p>
    </div>
  );
}